import { render, staticRenderFns } from "./ContactCentresIcon.vue?vue&type=template&id=7e23cc46&"
import script from "./ContactCentresIcon.vue?vue&type=script&lang=js&"
export * from "./ContactCentresIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports